import { Menu } from 'lucide-react'
import { UserMenu } from './UserMenu'
import { Tip } from '@/components/ui'

interface HeaderProps {
  onMenuClick: () => void
}

/**
 * The phone's top bar (SA-965, spec §3.5): the menu button that opens the
 * navigation drawer, and the user menu's avatar. `AppShell` renders it only
 * below `lg`; on desktop there is no bar and each page's own title band sits
 * at the top of the window.
 */
export function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="flex shrink-0 items-center justify-between h-14 px-4 bg-background border-b border-border lg:hidden print:hidden">
      <Tip text="Open navigation">
        <button
          onClick={onMenuClick}
          aria-label="Open navigation"
          className="p-2 rounded-md hover:bg-accent"
        >
          <Menu className="w-5 h-5" />
        </button>
      </Tip>

      <UserMenu variant="bar" />
    </header>
  )
}
